const commentItems = [
  {
    name: '漫画迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20Chinese%20boy%20with%20glasses%2C%20friendly%20smile%2C%20flat%20color%20style%2C%20minimal%20design%2C%20warm%20skin%20tone%2C%20clean%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '虫虫动漫的下拉式阅读真的太方便了！以前看漫画要一页一页翻，现在一口气就能看完整个章节，全集漫画完整版体验满分。最喜欢的《斗破苍穹》就是在这里一口气补完的！',
    manga: '斗破苍穹',
  },
  {
    name: '二次元达人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20Chinese%20girl%20with%20long%20hair%2C%20happy%20expression%2C%20flat%20color%20style%2C%20minimal%20design%2C%20warm%20skin%20tone%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '找了好久终于找到一个漫画大全平台，各种类型的漫画都能找到。完结版漫画资源很全，画质也很清晰。更新也快，每天都有新内容追，太良心了！',
    manga: '全职高手',
  },
  {
    name: '追漫老司机',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20Chinese%20man%20with%20cool%20expression%2C%20flat%20color%20style%2C%20minimal%20design%2C%20warm%20skin%20tone%2C%20clean%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '十年老漫迷强烈推荐！虫虫动漫的全卷完结漫画全集资源非常丰富，而且完全免费。下拉式浏览的设计真的懂我们这些追漫人，完整故事轻松读，不用反复翻页等加载。',
    manga: '魔道祖师',
  },
  {
    name: '深夜补漫人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20Chinese%20girl%20with%20ponytail%2C%20gentle%20smile%2C%20flat%20color%20style%2C%20minimal%20design%2C%20warm%20skin%20tone%2C%20clean%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    text: '每天晚上躺床上用手机看虫虫动漫，移动端适配做得很好，阅读流畅不卡顿。漫画完整版一次性看完的感觉太爽了，已经推荐给身边所有喜欢看漫画的朋友！',
    manga: '一人之下',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            漫友热评
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            听听漫画全集读者们的真实声音
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {commentItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={`${item.name}头像`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">在读《{item.manga}》</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              <div className="flex items-center gap-1 mt-3 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}